import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    getWebConfig: null,
    setWebConfig: ['data'],
    requestLogin: null,
    restoreUserSession: null,
    loginUser: ['username', 'password'],
    logoutUser: null,
    finalizeLogout: null,
    setRequiredQuestion: ['questionData'],
    setSignedIn: ['signedIn'],
    answerSecurityQuestion: ['answer'],
    setLoginError: ['errorCode', 'attemptCount'],
    setAccountData: ['accountData'],
    setUserInfo: ['userInfo'],
    setRoleInfo: ['userInfo'],
    processLoginCallback: null,
    finalizeLogin: null,
    setLoginCallbackStatus: null,
    resetAuth: null,
    clearToken: null
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    webConfig: null,
    signedIn: false,
    securityQuestionData: null,
    loginErrorCode: null,
    attemptCount: 0,
    accountData: null,
    userInfo: null,
    roleInfo: null
})

/* ------------- Reducers ------------- */
export const authResetAuth = (state) => INITIAL_STATE

export const authSetRequiredQuestion = (state, { questionData }) => 
    state.merge({ securityQuestionData: questionData })

export const authSetLoginError = (state, { errorCode, attemptCount }) =>
    state.merge({ loginErrorCode: errorCode, attemptCount: attemptCount })

export const authSetAccountData = (state, { accountData }) =>
    state.merge({ accountData: accountData, signedIn: Boolean(accountData) })

export const authSetUserInfo = (state, { userInfo }) =>
    state.merge({ userInfo: userInfo })

export const authSetRoleInfo = (state, { roleInfo }) =>
    state.merge({ roleInfo: roleInfo })

export const authProcessLoginCallback = (state) =>
    state.merge({ loginCallbackStatus: 'in_progress' })

export const authResetLoginErrror = (state, { username, password }) =>
    state.merge({ loginErrorCode: null, attemptCount: 0 })

export const authSetSignedIn = (state, { signedIn }) =>
    state.merge({ signedIn: signedIn })

export const authGetWebConfig = (state) =>
    state.merge({ loginCallbackStatus: 'in_progress' })

export const authSetWebConfig = (state, { data }) =>
    state.merge({ webConfig: data })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_SIGNED_IN]: authSetSignedIn,
    [Types.RESET_AUTH]: authResetAuth,
    [Types.SET_REQUIRED_QUESTION]: authSetRequiredQuestion,
    [Types.SET_LOGIN_ERROR]: authSetLoginError,
    [Types.SET_ACCOUNT_DATA]: authSetAccountData,
    [Types.LOGIN_USER]: authResetLoginErrror,
    [Types.ANSWER_SECURITY_QUESTION]: authResetLoginErrror,
    [Types.LOGOUT_USER]: authResetLoginErrror,
    [Types.SET_USER_INFO]: authSetUserInfo,
    [Types.PROCESS_LOGIN_CALLBACK]: authProcessLoginCallback,
    [Types.SET_ROLE_INFO]: authSetRoleInfo,
    [Types.GET_WEB_CONFIG]: authGetWebConfig,
    [Types.SET_WEB_CONFIG]: authSetWebConfig
})